import { Component, OnInit, Inject } from '@angular/core';
import { SystemAccountAuthModel } from '../../../../core/models/system-account';
import { Router } from '@angular/router';
import { IAuthService } from '../../../../core/services/api/contracts/auth-service';

@Component({
  selector: 'app-guest',
  templateUrl: './guest.component.html',
  styleUrls: ['./guest.component.scss', "../index/index.component.css"]
})
export class GuestHomeComponent implements OnInit {

  public currentUser: SystemAccountAuthModel;
  public isPatient: boolean = false;

  constructor(private router: Router,
    @Inject("IAuthService") private authService: IAuthService) { }

  async ngOnInit() {
    this.currentUser = await this.authService.getCurrentProfile();
    var user = this.currentUser.organizations[0].name.toString();
    if(user == 'PACIENTES')
    {
      this.isPatient= true;
    } 
  }

  async logout() {
    await this.authService.logout();
    await this.router.navigate(["/"]);
  }

  loadUserInfo() {
      if (this.currentUser && this.currentUser.email) {
          var user = this.currentUser.organizations[0].name.toString();
          if(this.isPatient)
          {
            user= "PACIENTE";
          }
      return `${user}`;
    } else {
      return "";
    }
  }

}
